import { render } from "./MypageUpdate.vue?vue&type=template&id=42fa061b"
import script from "./MypageUpdate.vue?vue&type=script&lang=js"
export * from "./MypageUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__